<div class="dashboard-controls" style="display: flex; gap: 15px; margin-bottom: 10px; align-items: center;">

  <div #selectComponent class="supers_facility_dd"></div>

  @if (widgetData.timeFilterTargets != undefined && widgetData.timeFilterTargets[0] != undefined) {
    <div class="filter-group">
      <label style="margin-right: 5px; font-weight: bold;">FY:</label>
      <select [(ngModel)]="selectedFY" (change)="onFilterChange()" class="form-control" style="width: 150px; display: inline-block;">
        @for (year of financialYears; track year) {
          <option [value]="year">{{ year }}</option>
        }
      </select>
    </div>
    <!-- <div class="filter-group">
    <label style="margin-right: 5px; font-weight: bold;">Timezone:</label>
    <select [(ngModel)]="selectedTimezone" (change)="onFilterChange()" class="form-control" style="width: 200px; display: inline-block;">
      <option *ngFor="let tz of timezones" [value]="tz.value">{{ tz.label }}</option>
    </select>
  </div> -->
}


</div>